document.addEventListener('DOMContentLoaded', () => {
    const toggles = document.querySelectorAll('.procedures-toggle');

    if (!toggles.length) return;

    const ensureCloseArea = (item, submenu) => {
        if (!item || !submenu) return;
        if (submenu.querySelector('.procedures-submenu__close')) return;

        const closeBtn = document.createElement('button');
        closeBtn.type = 'button';
        closeBtn.className = 'procedures-submenu__close';
        closeBtn.setAttribute('aria-label', 'Close submenu');
        submenu.appendChild(closeBtn);

        closeBtn.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            closeItem(item);
        });
    };

    const setSubmenuHeight = (item, submenu) => {
        if (!item || !submenu) return;
        const wasOpen = item.classList.contains('is-open');
        const prevHidden = submenu.hidden;
        const prevVisibility = submenu.style.visibility;
        const prevPosition = submenu.style.position;
        const prevPointer = submenu.style.pointerEvents;

        submenu.hidden = false;
        if (!wasOpen) {
            submenu.style.visibility = 'hidden';
            submenu.style.position = 'absolute';
            submenu.style.pointerEvents = 'none';
        }

        const height = submenu.scrollHeight;
        item.style.setProperty('--submenu-h', `${height}px`);
        if (!wasOpen) {
            submenu.hidden = prevHidden || true;
            submenu.style.visibility = prevVisibility;
            submenu.style.position = prevPosition;
            submenu.style.pointerEvents = prevPointer;
        }
        ensureCloseArea(item, submenu);
    };

    const closeItem = (item) => {
        const openToggle = item.querySelector(':scope .procedures-toggle');
        const openSubmenu = item.querySelector(':scope > .procedures-submenu');
        item.classList.remove('is-open');
        item.style.setProperty('--submenu-h', '0px');
        if (openToggle) openToggle.setAttribute('aria-expanded', 'false');
        if (openSubmenu) {
            const transitionMs = 450;
            openSubmenu.hidden = false;
            window.setTimeout(() => {
                if (!item.classList.contains('is-open')) {
                    openSubmenu.hidden = true;
                }
            }, transitionMs);
        }
    };

    toggles.forEach((toggle) => {
        const item = toggle.closest('li.menu-item-has-children');
        const submenu = item ? item.querySelector(':scope > .procedures-submenu') : null;
        setSubmenuHeight(item, submenu);

        toggle.addEventListener('click', (event) => {
            event.preventDefault();

            const list = toggle.closest('.procedures-list--accordion, .procedures-submenu');
            if (!item || !list || !submenu) return;

            const isOpen = item.classList.contains('is-open');

            list.querySelectorAll(':scope > li.menu-item-has-children.is-open').forEach((openItem) => {
                if (openItem === item) return;
                closeItem(openItem);
            });

            if (!isOpen) {
                setSubmenuHeight(item, submenu);
            }

            item.classList.toggle('is-open', !isOpen);
            toggle.setAttribute('aria-expanded', String(!isOpen));

            if (isOpen) {
                // keep visible during close transition
                submenu.hidden = false;
                item.style.setProperty('--submenu-h', '0px');
                window.setTimeout(() => {
                    if (!item.classList.contains('is-open')) {
                        submenu.hidden = true;
                    }
                }, 450);
            } else {
                submenu.hidden = false;
            }

            const rootList = toggle.closest('.procedures-list--accordion');
            if (rootList) {
                rootList.classList.toggle(
                    'has-open',
                    rootList.querySelector(':scope > li.menu-item-has-children.is-open') !== null
                );
            }
        });
    });

    window.addEventListener('resize', () => {
        document.querySelectorAll('li.menu-item-has-children').forEach((item) => {
            const submenu = item.querySelector(':scope > .procedures-submenu');
            if (!submenu) return;
            setSubmenuHeight(item, submenu);
        });
    });
});
